"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = Logo;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Logo() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['logo']
  }, /*#__PURE__*/React.createElement("svg", {
    width: "60",
    height: "85",
    viewBox: "0 0 60 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.727 41.203L40.403 53.986V42.657H51.085V66.777L59.453 76.797L49.565 85L29.727 61.247L9.88901 85L0 76.797L29.727 41.203ZM45.58 0C53.544 0 60 6.434 60 14.373C60 17.633 58.91 20.638 57.074 23.05L45.58 37.037L35.045 24.375L34.087 23.052C33.775 22.642 33.485 22.216 33.219 21.774C31.8681 19.5419 31.1556 16.982 31.159 14.373C31.159 6.434 37.615 0 45.579 0H45.58ZM45.58 7.75C41.928 7.75 38.968 10.7 38.968 14.34C38.968 17.98 41.928 20.93 45.58 20.93C49.232 20.93 52.192 17.98 52.192 14.34C52.192 10.7 49.232 7.75 45.58 7.75Z",
    fill: "#0468FF"
  }))));
}